// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Wallet.css
// module id = 1111
// module chunks = 0